"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateAssetRequestToJSON = exports.CreateAssetRequestFromJSONTyped = exports.CreateAssetRequestFromJSON = exports.instanceOfCreateAssetRequest = void 0;
var runtime_1 = require("../runtime");
var AssetSubtype_1 = require("./AssetSubtype");
var AssetType_1 = require("./AssetType");
var AudioCreationProperties_1 = require("./AudioCreationProperties");
/**
 * Check if a given object implements the CreateAssetRequest interface.
 */
function instanceOfCreateAssetRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "assetType" in value;
    isInstance = isInstance && "name" in value;
    return isInstance;
}
exports.instanceOfCreateAssetRequest = instanceOfCreateAssetRequest;
function CreateAssetRequestFromJSON(json) {
    return CreateAssetRequestFromJSONTyped(json, false);
}
exports.CreateAssetRequestFromJSON = CreateAssetRequestFromJSON;
function CreateAssetRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'assetType': (0, AssetType_1.AssetTypeFromJSON)(json['asset_type']),
        'assetSubtype': !(0, runtime_1.exists)(json, 'asset_subtype') ? undefined : (0, AssetSubtype_1.AssetSubtypeFromJSON)(json['asset_subtype']),
        'name': json['name'],
        'audioCreationProperties': !(0, runtime_1.exists)(json, 'audio_creation_properties') ? undefined : (0, AudioCreationProperties_1.AudioCreationPropertiesFromJSON)(json['audio_creation_properties']),
    };
}
exports.CreateAssetRequestFromJSONTyped = CreateAssetRequestFromJSONTyped;
function CreateAssetRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'asset_type': (0, AssetType_1.AssetTypeToJSON)(value.assetType),
        'asset_subtype': (0, AssetSubtype_1.AssetSubtypeToJSON)(value.assetSubtype),
        'name': value.name,
        'audio_creation_properties': (0, AudioCreationProperties_1.AudioCreationPropertiesToJSON)(value.audioCreationProperties),
    };
}
exports.CreateAssetRequestToJSON = CreateAssetRequestToJSON;
